import React, { useEffect, useState } from 'react';
import client from '../../../utils/prismicHelpers';
import * as queries from "../../../utils/prismicQueries";
import './academic.css'
import { useNavigate } from 'react-router';
import AcademicCard from './AcademicCard';
const AcademicInitiatives = () => {

    const [academicDoc, setAcademicDoc] = useState(null);
    const navigate = useNavigate();
    const handlNaviagtiton = (route) => {
        navigate(route)

        // Emitter.emit("MOVE_SECTION", 4);

    }

    useEffect(() => {
        client
            .query({
                query: queries.academicInfo,
            })
            .then((response) => {
                const academicInfo = response.data.allAcademicinitiativess.edges[0].node;
                setAcademicDoc(academicInfo);


            })
            .catch((error) => {
                console.error(error);
            });
    });



    return (
        <>

            <section style={
                { background: `url(${academicDoc?.section_bg?.url})` }}
                className="academic-section " >
                < div className="container " >
                    <h5 className="section-title  pb-4" > Academic Initiatives </h5>
                    < div className="row gx-2  gy-2" >

                        {
                            academicDoc?.card_info?.map((info, index) =>
                                < AcademicCard
                                    key={index + 1}
                                    index={index + 1}
                                    info={info}
                                    handlNaviagtiton={handlNaviagtiton} >
                                </AcademicCard>
                            )
                        }

                    </div>
                </div>
            </section >

        </>
    );
};

export default AcademicInitiatives;